'use client'
import {
  Button_default
} from "./chunk-EGOGHW2A.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Tabs/Tabs.tsx
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var Tabs = ({
  tabs,
  groupClassName,
  className,
  defaultValue,
  value,
  onValueChange,
  orientation,
  activationMode,
  forceMount,
  ref
}) => {
  return /* @__PURE__ */ jsxs(
    TabsPrimitive.Root,
    {
      defaultValue,
      value,
      onValueChange,
      orientation,
      activationMode,
      className: groupClassName,
      ref,
      children: [
        /* @__PURE__ */ jsx(TabsPrimitive.List, { className: twMerge("space-x-S border-paper border-b", className), children: tabs.map((tab, i) => {
          var _a;
          return /* @__PURE__ */ jsx(
            TabsPrimitive.Trigger,
            {
              value: tab.value,
              tabIndex: i == 0 ? 0 : -1,
              asChild: true,
              children: /* @__PURE__ */ jsx(
                Button_default,
                __spreadProps(__spreadValues({
                  theme: "action",
                  shape: "text",
                  disabled: tab.disabled,
                  rounded: false
                }, tab.buttonProps), {
                  className: twMerge(
                    "py-XS data-[state=active]:border-body-dark -mb-px border-b-2 border-transparent px-px",
                    (_a = tab.buttonProps) == null ? void 0 : _a.className
                  ),
                  children: tab.label
                })
              )
            },
            tab.value
          );
        }) }),
        tabs.map((tab) => /* @__PURE__ */ jsx(
          TabsPrimitive.Content,
          {
            className: "outline-none",
            value: tab.value,
            forceMount,
            tabIndex: -1,
            children: tab.content
          },
          tab.value
        ))
      ]
    }
  );
};
var Tabs_default = Tabs;

export {
  Tabs_default
};
//# sourceMappingURL=chunk-LIC2TZ7L.mjs.map